import Logo from './landing/components/Logo';
import { SITE } from './config/site';

const COLUMNS = [
  {
    title: 'Product',
    links: [
      { name: 'Upload a log', page: 'fullLogUpload' },
      { name: 'Analytics', page: 'analytics' },
      { name: 'Ledger', page: 'ledger' },
      { name: 'Bankroll', page: 'bankroll' },
      { name: 'Pricing', page: 'payment' },
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About', page: 'about' },
      { name: 'FAQ', page: 'faq' },
      { name: 'Contact', page: 'contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Privacy', page: 'privacy' },
      { name: 'Terms', page: 'terms' },
    ],
  },
];

const Footer = ({ setCurrentPage }) => {
  const go = page => e => {
    e.preventDefault();
    setCurrentPage(page);
    window.scrollTo({ top: 0 });
  };

  return (
    <footer className="mt-auto bg-pn-bg text-pn-fg">
      <div className="mx-auto max-w-[1480px] px-4 pb-10 pt-20 sm:px-6">
        <div className="grid gap-12 border-t border-pn-line/10 pt-12 md:grid-cols-[1.4fr_repeat(3,minmax(0,1fr))]">
          <div className="max-w-xs">
            <a href="/" onClick={go('home')} className="pn-link inline-block text-pn-fg">
              <Logo className="h-8 w-auto" />
            </a>
            <p className="pn-body mt-4 text-[0.95rem]">
              Hand history analytics and settle-ups for PokerNow home games.
            </p>
          </div>

          {COLUMNS.map(col => (
            <nav key={col.title} aria-label={col.title}>
              <h2 className="text-sm font-bold">{col.title}</h2>
              <ul className="mt-4 space-y-2.5">
                {col.links.map(link => (
                  <li key={link.page}>
                    <a href={`/${link.page}`} onClick={go(link.page)} className="pn-link text-[0.95rem]">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-16 flex flex-col gap-4 text-sm text-pn-muted sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {new Date().getFullYear()} {SITE.company}. Not affiliated with PokerNow.club.
          </p>
          <div className="flex items-center gap-5">
            <a href={SITE.github} target="_blank" rel="noopener noreferrer" className="pn-link">GitHub</a>
            <a href={SITE.linkedin} target="_blank" rel="noopener noreferrer" className="pn-link">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
